import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyStatement = {
  // 获取酒店报表
  getHotelOrderReport(params) {
    return http.post(`${baseUrl}Company/hotelOrderReport`, params)
  },
  // 获取机票报表
  getPlaneOrderReport(params) {
    return http.post(`${baseUrl}Company/planeOrderReport`, params)
  },
  // 获取火车票报表
  getTrainOrderReport(params) {
    return http.post(`${baseUrl}Company/trainOrderReport`, params)
  },
  // 获取报表
  // saleDayByLidianQueryData(params) {
  //   return http.post(`${otherUrl}Home/ReportCache/saleDayByLidianQueryData`, params)
  // },

}



// WEBPACK FOOTER //
// ./src/api/companyStatement.js